<template lang="pug">
  el-footer(:class="$style.layout")
    p
      span HVU is a creation of &nbsp;
      a(href="https://hvullc.com/about" target="_blank")
        | Tim Hanshaw
      span . &nbsp;Copyright &copy; {{ fullYear }} Hanshaw Virtual University. All rights reserved.
</template>

<script>
  export default {
    data() {
      return {
        fullYear: new Date().getFullYear(),
      }
    },
  }
</script>

<style module>
  .layout {
    width: 100%;
    background-color: var(--dark-gray);
    color: #fff;

    & p {
      float: right;
      margin-top: 15px;
      margin-right: 20px;
    }

    & a {
      color: var(--light-blue-one);
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/FooterComponent/FooterComponent.vue